class PaintCalculator extends HTMLElement {
  constructor() {
    super();
    this.opener = document.querySelectorAll('paint-calculator-opener');

    this.formData = {
      'items': []
    }

    if(this.opener) {
      this.closer = this.querySelector('.paint-calculator__close');
      this.surface = this.querySelector('[data-add-surface]');
      this.buyButton = this.querySelector('.paint-calculator__result--purchase-button button');

      this.radios = this.querySelectorAll('input[name="finish"]');

      this.listeners(this.formData);
    }

    this.filter = document.querySelector('.js-paint-calculator-range-filter');
    if(this.filter){
      this.listenersFilter();
    }
  }

  round(num) {
    return num % 1 === 0 ? num : num.toFixed(2);
  }

  listeners(formData) {

    this.opener.forEach((opener) => {
      opener.addEventListener('click', this.open.bind(this));   
    });
    if(this.closer) {
      this.closer.addEventListener('click', this.close.bind(this));
    }
    this.surface.addEventListener('click', this.addSurface.bind(this));
 
    this.radios.forEach((radio) => {
      radio.addEventListener('click', () => {
        radio.checked = true;
        this.updateValues(this.formData);
      });
    })
}

  listenersFilter(){
    var filters = document.querySelectorAll(".js-paint-calculator-range-filter");
    var rangeLookupTarget = document.querySelector('.js-range-lookup');

    if (!filters || !rangeLookupTarget) return;

        var select = document.querySelector(".js-paint-calculator-range-select");
        var rangeLookup = JSON.parse(rangeLookupTarget.textContent);
        var measurementInputs = this.querySelectorAll('input[type="number"]');
        var link = this.querySelector('.paint-calculator__link');

          rangeLookup.forEach(item => {
            var itemFinish = item.finish.toLowerCase();
            var selectValue = select.value.toLowerCase();
            
            if(selectValue == itemFinish) {
              this.calc(item);
            }
          });
          

        filters.forEach(el => {
          el.addEventListener('click', () => {
            let filterGroup = el.getAttribute('data-group');
            select.length = 0;
            if(filterGroup == '1829') {
              link.href = "/collections/all-ranges-1829-vintage-collection";
            } else if(filterGroup == 'Abigail Ahern') {
              link.href = "/collections/all-ranges-abigail-ahern";
            } else if(filterGroup == 'Artisan')  {
              link.href = "/collections/all-ranges-artisan-special-effects";
            }
            link.firstElementChild.innerHTML = filterGroup;
            rangeLookup.forEach(item => {
              if(item.group == filterGroup){
                var option = document.createElement("option");
                option.text = item.finish;
                select.add(option);
                if(select.value == item.finish) {
                  this.calc(item);
                }
              }
            });
          });
        });


      select.addEventListener('change', () => {
        rangeLookup.forEach(item => {
          var itemFinish = item.finish.toLowerCase();
          var selectValue = select.value.toLowerCase();

          if(selectValue == itemFinish) {
            this.calc(item);
          }
        });
      });

      measurementInputs.forEach((input) => {
        input.addEventListener('keyup', () => {
          rangeLookup.forEach(item => {

            var itemFinish = item.finish.toLowerCase();
            var selectValue = select.value.toLowerCase();
    
    
            if(selectValue == itemFinish) {
          
              this.calc(item);
            }
          });
        });
      })
   }



  calc(item) {
    let litresNeeded = item.litres_needed || 0;
    let coatsNeeded = item.coats_needed  || 1;
    let allSurfaces = this.querySelectorAll('.paint-calculator__surface');
    let allValues = [];

    // Get each input within those sets
    allSurfaces.forEach((surface) => {
      let inputs = surface.querySelectorAll('input[type="number"]');
      let values = [];
      inputs.forEach((input) => {
        values.push(input.value)
      })
      
      // Multiply each input to get total metres needed
      let total = values.reduce((accumulator, current) => accumulator*current,1);
      allValues.push(total);
    })

     // Add multiple sets together to get final value
     let totalCoverage = allValues.reduce((accumulator, current) => accumulator+current,0)
     let finalValue = (totalCoverage * litresNeeded) * coatsNeeded; 
     let finalValueSize =  this.round(finalValue);

    if(finalValueSize > 0) {
      let coverageMessage = window.paintCalculatorStrings.coverage.replace('[coverage]', totalCoverage).replace('[coats]', coatsNeeded);

      this.querySelector('.paint-calculator__result').classList.remove('hidden');
      this.querySelector('.paint-calculator__recommended-size span').innerHTML = finalValueSize;

      if (coatsNeeded == 1) {
        coverageMessage = window.paintCalculatorStrings.coverageOneCoat.replace('[coverage]', totalCoverage);
      }

      this.querySelector('.paint-calculator__recommended-coverage').innerHTML = coverageMessage;
    }  
  }

  open() {
    this.setAttribute('open', '');
    document.body.classList.add('overflow-hidden');
    this.paintCalculator();
  }

  close() {
    this.removeAttribute('open');
    document.body.classList.remove('overflow-hidden');
  }

  addSurface() {
    let allSurfaces = this.querySelectorAll('.paint-calculator__surface');
    let surface = this.querySelector('.paint-calculator__surfaces').lastElementChild;
    let clone = surface.cloneNode(true);
    let currentCount = allSurfaces.length;
    let label = clone.querySelector('.paint-calculator__surface-label');
    label = label.innerHTML.replace(currentCount, currentCount + 1);
    clone.querySelector('.paint-calculator__surface-label').innerHTML = label;
    clone.querySelectorAll('input[type="number"]').forEach((input) => {
      input.value = '';
    });
    if(clone.innerHTML.indexOf('<p class="remove"></p>') === -1) {
      clone.innerHTML += `<p class="remove"></p>`
    }
    surface.after(clone);
    if(this.classList.contains('paint-calculator--popup')){
      this.paintCalculator();
    } else {
      this.listenersFilter();
    }
    this.removeSurface();
  }

  removeSurface() {
    let allRemoves = this.querySelectorAll('.paint-calculator__surface .remove');
    allRemoves.forEach((remove) => {
      remove.addEventListener('click', () => {
        remove.parentNode.remove();
        if(this.classList.contains('paint-calculator--popup')){
          this.updateValues();
        } else {
          this.listenersFilter();
        }
      });
    });
    
  }

  calculations() {    
    let selectedFinish;
    this.variantData = this.variantData || JSON.parse(this.querySelector('.js-paint-calculator-variants').textContent);
    if (this.querySelector('input[name="finish"]:checked')) {
      selectedFinish = this.querySelector('input[name="finish"]:checked').value;
    } else {
      selectedFinish = null;
    }
    
    let litresNeeded = 0;
    let coatsNeeded = 1;

    this.variantData.forEach((variant) => {
      if (variant.options.includes(selectedFinish) || selectedFinish == null) {
        litresNeeded = variant.litres_needed
        coatsNeeded = variant.coats_needed
      }
    })

    // Get all input sets
    let allSurfaces = this.querySelectorAll('.paint-calculator__surface');
    let allValues = [];

    // Get each input within those sets
    allSurfaces.forEach((surface) => {
      let inputs = surface.querySelectorAll('input[type="number"]');
      let values = [];
      inputs.forEach((input) => {
        values.push(input.value)
      })
      
      // Multiply each input to get total metres needed
      let total = values.reduce((accumulator, current) => accumulator*current,1);
      allValues.push(total);
    })

    // Add multiple sets together to get final value
    let totalCoverage = allValues.reduce((accumulator, current) => accumulator+current,0)
    let finalValue = (totalCoverage * litresNeeded) * coatsNeeded; 

    return {
      coverage: this.round(totalCoverage),
      size: this.round(finalValue),
      coats: coatsNeeded
    }

  }

  updateValues(formData) {
    const recommendedSizeValue = this.calculations().size > 0 ? this.calculations().size : 0;
    const recommendedCoverageValue = this.calculations().coverage > 0 ? this.calculations().coverage : 0;
    const recommendedCoatsValue = this.calculations().coats;

    const results =  this.querySelector('.paint-calculator__result');
    const coverageTarget =  this.querySelector('.paint-calculator__recommended-coverage');
    const sizeTarget = this.querySelector('.paint-calculator__recommended-size span');
    const purchaseButton = this.querySelector('.paint-calculator__result--purchase-button');

    let coverageMessage = window.paintCalculatorStrings.coverage.replace('[coverage]', recommendedCoverageValue).replace('[coats]', recommendedCoatsValue);

    if (recommendedCoatsValue == 1) {
      coverageMessage = window.paintCalculatorStrings.coverageOneCoat.replace('[coverage]', recommendedCoverageValue);
    }
    
    coverageTarget.innerHTML = coverageMessage;
    sizeTarget.innerHTML = recommendedSizeValue
    results.classList.remove('hidden');
    purchaseButton.classList.remove('hidden');

    this.productRender(this.formData);
  }

  paintCalculator() {
    let measurementInputs = this.querySelectorAll('input[type="number"]');
    measurementInputs.forEach((input) => {
      input.addEventListener('keyup', () => {
        this.updateValues();
      });
    })
  }

  productRender(formData) {
    this.formData.items.length = 0;
    let productsNeeded = []
    let sizeVariants = [];

    this.variantData = this.variantData || JSON.parse(this.querySelector('.js-paint-calculator-variants').textContent);

    let selectedFinish; 
    
    if (this.querySelector('input[name="finish"]:checked')) {
      selectedFinish = this.querySelector('input[name="finish"]:checked').value
    } else {
      selectedFinish = null;
    };


    this.variantData.forEach((variant) => {
      if (variant.options.includes(selectedFinish) || selectedFinish == null) {
        let finish = variant.options;

        if (selectedFinish != null) {
          let lowercaseFinish = selectedFinish.toLowerCase();
          finish.forEach((option) => {
            option = option.toLowerCase();
            if (option != lowercaseFinish && !option.includes('sample') && !option.includes('patch')) {
              sizeVariants.push(option)
            }
          })
        } else {

          this.querySelector('.paint-calculator__result-radios').classList.add('hidden');

          finish.forEach((option) => {
            option = option.toLowerCase();
            if (!option.includes('sample') && !option.includes('patch')) {
              sizeVariants.push(option)
            }
          })
        }
      }
    })

    sizeVariants.map(item => {
      let index = sizeVariants.indexOf(item);
      if (!item.includes('ml')) {
        if (~index) {
          sizeVariants[index] = `${parseFloat(item)*1000}:${item}`;
        }
      } else {
        if (~index) {
          sizeVariants[index] = `${parseFloat(item)}:${item}`;
        }
      }
    })
    

    let recommendedSizeValue = this.calculations().size * 1000;

    let paintNeeded = recommendedSizeValue
    let litresUsed = 0;
    let counts = []
    let need = [];

    sizeVariants.forEach((item, key, sizeVariants) => {
      counts.push(parseFloat(item.split(':')[0]))
    })

    do {
      var closest = counts.reduce(function(prev, curr) {
        paintNeeded = paintNeeded - litresUsed;
        return (Math.abs(curr - paintNeeded) < Math.abs(prev - paintNeeded) ? curr : prev);
      });
      need.push(closest)
      paintNeeded = paintNeeded - closest;
    } while (paintNeeded > 0);

    need.forEach((val) => {
      sizeVariants.forEach((item) => {
        if (val == parseFloat(item.split(':')[0])) {
          productsNeeded.push({ size: item.split(':')[0], quantity: 1,  variant: item.split(':')[1] });
        }
      })
    })

    let result = [];

    productsNeeded.forEach(function (a) {

    if (!this[a.size]) {
        this[a.size] = { size: a.size, quantity: 0, variant: a.variant };
        result.push(this[a.size]);
    }
    this[a.size].quantity += a.quantity;
}, Object.create(null));

    let resultContainer = this.querySelector('.paint-calculator__purchase-amount');
    resultContainer.innerHTML = '';
    let products = []

    result.forEach(function (product) {

      resultContainer.innerHTML += `<p>${product.quantity} x ${product.variant}</p>`

      products.push({
        quantity: product.quantity,
        variant: product.variant
      })
      
    })

    let totalPrice = 0;

    this.variantData.forEach((variant) => {
      if (variant.options.includes(selectedFinish) || selectedFinish == null) {
        let finish = variant.options;
        finish.forEach((option) => {
          option = option.toLowerCase();
          products.forEach((prod) => {
            if (option == prod.variant) {
              formData.items.push({ 'id': variant.id, 'quantity': prod.quantity })
              totalPrice = totalPrice += variant.price * prod.quantity
            }
          })
        })
      }
    })

    this.querySelector('.paint-calculator__purchase-cost').innerHTML = Shopify.formatMoney(totalPrice, window.moneyFormat.format);
    this.querySelector('.button-price').innerHTML = Shopify.formatMoney(totalPrice, window.moneyFormat.format);
    
    this.buyButton.addEventListener('click', () => {
      this.productAdd(formData);
    })

  }

  productAdd(formData) {
    const max = 99;
    const sections = ['stmt-popout-cart-delivery-banner', 'stmt-popout-cart-items', 'stmt-popout-cart-footer'];
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      body: JSON.stringify({ items: formData.items, max: max, sections: sections }),
      headers: { 'Content-type': 'application/json' },
      credentials: 'include'
    })
    .then(res => {
      return res.json();
    })
    .then((res) => {
       fetch(`${routes.cart_url}.json`)
       .then((res) => {
         return res.json();
       })
       .then((cart) => {
         fetch(`/?sections=${sections}`)
         .then((res) => {
           return res.text();
         })
         .then((section) => {

           document.dispatchEvent(
             new CustomEvent('popout-cart:show')
           );

         
           document.dispatchEvent(
             new CustomEvent('cart:requestComplete', { 
               detail: {
                 data: {
                   ...cart,
                   sections: JSON.parse(section)
                 }
               }
             })
           )

         })
       })
    })
    .catch((error) => {
      console.error('Error:', error);
   });
  }

}
customElements.define('paint-calculator', PaintCalculator);
